/** @file basisQuat: the Babylon rotation that takes its local axes to three z-up world directions. */
import { Matrix, Quaternion } from '@babylonjs/core/Maths/math.vector.js';
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';

/** Scratch matrix (the per-frame callers pass their own `out`; nothing is allocated per call). */
const M = new Matrix();

/**
 * The rotation taking Babylon's local x, y, z to the z-up world directions `x`, `y`, `z` x `zSign` (each swapped to
 * Babylon's y-up frame as `toBabylonVec3` does). The three must form a proper rotation in Babylon's frame (the
 * callers pass gizmo axes X, Z, Y or the view's right, up, -back).
 */
export function basisQuat(x: Vec3, y: Vec3, z: Vec3, out: Quaternion, zSign = 1): Quaternion {
  Matrix.FromValuesToRef(
    x[0], x[2], x[1], 0, y[0], y[2], y[1], 0, z[0] * zSign, z[2] * zSign, z[1] * zSign, 0, 0, 0, 0, 1, M,
  );
  return Quaternion.FromRotationMatrixToRef(M, out);
}
